<div class="bg-(--toolbar-color) h-[50px]">
  <div class="w-6xl mx-auto h-full flex flex-row justify-between items-center">
    <span class="text-white">
      <a [routerLink]="['/projects', project().id]" aria-label="Back to projects" i18n-aria-label
        class="size-fit flex flex-row items-center">
        <mat-icon class="size-fit! text-base! text-inherit!">arrow_back</mat-icon>
        <span class="text-sm italic" i18n>back to project detail</span>
      </a>
    </span>
    <span class="mr-5">
      <a class="bg-(--brand-button-active-fill)! mr-2! px-4! h-8!" matButton="filled" i18n-aria-label
        aria-label="Invite Participants" [routerLink]="['/projects', projectView().id, 'invite']"
        [state]="{ showLoading: false }">
        Invite Participants
      </a>
    </span>
  </div>
</div>
<div class="w-6xl mx-auto flex flex-col text-(--toolbar-color)">
  <span class="text-base font-semibold py-4">{{ projectView().name }}</span>
</div>
<div class="w-lvw bg-(--download-bar-color) text-white">
  <div class="w-6xl mx-auto h-10 flex items-center">
    @if (hasAnyPotentialReports()) {
    <button matFab extended type="button" [disabled]="downloading()" (click)="download()">
      <mat-icon class="text-base! text-inherit!">download_2</mat-icon>
      <span class="text-sm" i18n>download reports</span>
    </button>
    }
  </div>
</div>
<div class="w-6xl mx-auto grid grid-rows-[1fr_auto] grid-cols-[70%_30%]">
  <mat-table [dataSource]="viewData()" matSort aria-label="Project participants" i18n-aria-label
    class="h-[calc(100vh-40px-56px-50px-50px)] overflow-y-scroll overflow-hidden">
    <!-- First Name Column -->
    <ng-container matColumnDef="firstName">
      <mat-header-cell *matHeaderCellDef mat-sort-header="firstName" i18n>First Name</mat-header-cell>
      <mat-cell *matCellDef="let p">{{ p.firstName }}</mat-cell>
    </ng-container>

    <!-- Last Name Column -->
    <ng-container matColumnDef="lastName">
      <mat-header-cell *matHeaderCellDef mat-sort-header="lastName" i18n>Last Name</mat-header-cell>
      <mat-cell *matCellDef="let p">{{ p.lastName }}</mat-cell>
    </ng-container>

    <!-- Email Column -->
    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header="email" i18n>Email</mat-header-cell>
      <mat-cell *matCellDef="let p">{{ p.email }}</mat-cell>
    </ng-container>

    <!-- Completion Dates Column -->
    <ng-container matColumnDef="completionDates">
      <mat-header-cell *matHeaderCellDef mat-sort-header="completionDates" i18n>Completed</mat-header-cell>
      <mat-cell *matCellDef="let p">
        @if(p.completed == p.total) {
        {{ p.latest | date }}
        }@else{
        {{ p.completed + ' of ' + p.total }}
        }
      </mat-cell>
    </ng-container>

    <!-- Secondary Column -->
    <ng-container matColumnDef="footer">
      <mat-footer-cell colspan="3" *matFooterCellDef colspan="3">
        <mat-paginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons
          aria-label="Participant table pagination" i18n-aria-label class="col-span-2 h-[50px]"></mat-paginator>
      </mat-footer-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="['firstName', 'lastName', 'email', 'completionDates']; sticky: true"></mat-header-row>
    <mat-row matRipple *matRowDef="let row; columns: ['firstName', 'lastName', 'email', 'completionDates']"
      class="clickable-row" (click)="selectParticipant(row)"></mat-row>
    <mat-footer-row *matFooterRowDef="['footer']; sticky: true"></mat-footer-row>
  </mat-table>
  <div class="bg-[#e7ebec]">
    <router-outlet></router-outlet>
  </div>
</div>